/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geo_Label_AfricaInputs */

const bn_geo_label_africa = /** @type {(inputs: Geo_Label_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আফ্রিকা`)
};

const de_geo_label_africa = /** @type {(inputs: Geo_Label_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrika`)
};

const el_geo_label_africa = /** @type {(inputs: Geo_Label_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αφρική`)
};

const en_geo_label_africa = /** @type {(inputs: Geo_Label_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Africa`)
};

const es_geo_label_africa = /** @type {(inputs: Geo_Label_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`África`)
};

const fr_geo_label_africa = /** @type {(inputs: Geo_Label_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrique`)
};

const hi_geo_label_africa = /** @type {(inputs: Geo_Label_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अफ़्रीका`)
};

const hu_geo_label_africa = /** @type {(inputs: Geo_Label_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrika`)
};

const id_geo_label_africa = /** @type {(inputs: Geo_Label_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrika`)
};

const it_geo_label_africa = /** @type {(inputs: Geo_Label_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Africa`)
};

const ja_geo_label_africa = /** @type {(inputs: Geo_Label_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アフリカ`)
};

const ko_geo_label_africa = /** @type {(inputs: Geo_Label_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아프리카`)
};

const nl_geo_label_africa = /** @type {(inputs: Geo_Label_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrika`)
};

const pl_geo_label_africa = /** @type {(inputs: Geo_Label_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afryka`)
};

const pt_geo_label_africa = /** @type {(inputs: Geo_Label_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`África`)
};

const ru_geo_label_africa = /** @type {(inputs: Geo_Label_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Африка`)
};

const sv_geo_label_africa = /** @type {(inputs: Geo_Label_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrika`)
};

const tr_geo_label_africa = /** @type {(inputs: Geo_Label_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrika`)
};

const uk_geo_label_africa = /** @type {(inputs: Geo_Label_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Африка`)
};

const vi_geo_label_africa = /** @type {(inputs: Geo_Label_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Châu phi`)
};

const zh_geo_label_africa = /** @type {(inputs: Geo_Label_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非洲`)
};

const zh_hant_geo_label_africa = /** @type {(inputs: Geo_Label_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非洲`)
};

/**
* | output |
* | --- |
* | "Africa" |
*
* @param {Geo_Label_AfricaInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const geo_label_africa = /** @type {((inputs?: Geo_Label_AfricaInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geo_Label_AfricaInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_geo_label_africa(inputs)
	if (locale === "de") return de_geo_label_africa(inputs)
	if (locale === "el") return el_geo_label_africa(inputs)
	if (locale === "en") return en_geo_label_africa(inputs)
	if (locale === "es") return es_geo_label_africa(inputs)
	if (locale === "fr") return fr_geo_label_africa(inputs)
	if (locale === "hi") return hi_geo_label_africa(inputs)
	if (locale === "hu") return hu_geo_label_africa(inputs)
	if (locale === "id") return id_geo_label_africa(inputs)
	if (locale === "it") return it_geo_label_africa(inputs)
	if (locale === "ja") return ja_geo_label_africa(inputs)
	if (locale === "ko") return ko_geo_label_africa(inputs)
	if (locale === "nl") return nl_geo_label_africa(inputs)
	if (locale === "pl") return pl_geo_label_africa(inputs)
	if (locale === "pt") return pt_geo_label_africa(inputs)
	if (locale === "ru") return ru_geo_label_africa(inputs)
	if (locale === "sv") return sv_geo_label_africa(inputs)
	if (locale === "tr") return tr_geo_label_africa(inputs)
	if (locale === "uk") return uk_geo_label_africa(inputs)
	if (locale === "vi") return vi_geo_label_africa(inputs)
	if (locale === "zh") return zh_geo_label_africa(inputs)
	return zh_hant_geo_label_africa(inputs)
});